import { render, staticRenderFns } from "./textBoxMatchMaking.vue?vue&type=template&id=a1439290&scoped=true"
import script from "./textBoxMatchMaking.vue?vue&type=script&lang=js"
export * from "./textBoxMatchMaking.vue?vue&type=script&lang=js"
import style0 from "./textBoxMatchMaking.vue?vue&type=style&index=0&id=a1439290&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1439290",
  null
  
)

export default component.exports